import { handleActions } from 'redux-actions';

import * as types from './types';

import { groupByTimesheet } from '../../helpers/utils';

const initialState = {
  done: {
    data: [],
    error: null,
    initialLoad: false,
    loading: false,
    saving: false,
  },
  doneByEmployee: {
    data: [],
    error: null,
    initialLoad: false,
    loading: false,
    saving: false,
  },
  doneByPeriod: {
    data: [],
    error: null,
    initialLoad: false,
    loading: false,
    saving: false,
  },
  doneByProject: {
    data: [],
    error: null,
    initialLoad: false,
    loading: false,
    saving: false,
  },
  doneByClient: {
    data: [],
    error: null,
    initialLoad: false,
    loading: false,
    saving: false,
  },
  todo: {
    data: [],
    error: null,
    initialLoad: false,
    loading: false,
    saving: false,
  },
  todoByEmployee: {
    data: [],
    error: null,
    initialLoad: false,
    loading: false,
    saving: false,
  },
  todoByPeriod: {
    data: [],
    error: null,
    initialLoad: false,
    loading: false,
    saving: false,
  },
  todoByProject: {
    data: [],
    error: null,
    initialLoad: false,
    loading: false,
    saving: false,
  },
};

const approveRequest = (state) => ({
  ...state,
  todo: {
    ...state.todo,
    error: null,
    loading: false,
    saving: true,
  },
});
const approveRequestFailure = (state, action) => ({
  ...state,
  todo: {
    ...state.todo,
    error: action.error,
    saving: false,
  },
});
const approveRequestSuccess = (state) => ({
  ...state,
  todo: {
    ...state.todo,
    error: null,
    saving: false,
  },
});

const declineRequest = (state) => ({
  ...state,
  todo: {
    ...state.todo,
    error: null,
    loading: false,
    saving: true,
  },
});
const declineRequestFailure = (state, action) => ({
  ...state,
  todo: {
    ...state.todo,
    error: action.error,
    saving: false,
  },
});
const declineRequestSuccess = (state) => ({
  ...state,
  todo: {
    ...state.todo,
    error: null,
    saving: false,
  },
});

const getDoneApprovalsRequest = (state, payload) => {
  if (payload.data?.groupBy) {
    const key = `doneBy${payload.data.groupBy.charAt(0).toUpperCase()}${payload.data.groupBy.slice(1)}`;
    return {
      ...state,
      [key]: {
        ...state[key],
        error: null,
        loading: true,
      },
    };
  }
  return {
    ...state,
    done: {
      ...state.done,
      error: null,
      loading: true,
    },
  };
};

const getDoneApprovalsRequestFailure = (state, action) => {
  if (action.data?.groupBy) {
    const key = `doneBy${action.data.groupBy.charAt(0).toUpperCase()}${action.data.groupBy.slice(1)}`;
    return {
      ...state,
      [key]: {
        ...state[key],
        error: action.error,
        loading: false,
      },
    };
  }
  return {
    ...state,
    done: {
      ...state.done,
      error: action.error,
      loading: false,
    },
  };
};

const getDoneApprovalsRequestSuccess = (state, payload) => {
  if (payload.data?.groupBy) {
    if (/^(project|client)$/.test(payload.data.groupBy)) {
      const formattedData = payload.data.res.map((groupObj) => {
        const newGroupObj = {
          name: `${groupObj.key.externalId}--${groupObj.key.name}`,
          data: groupByTimesheet(groupObj.data),
        };
        return newGroupObj;
      });
      if (payload.data.groupBy.indexOf('oject') > -1) {
        return {
          ...state,
          doneByProject: {
            ...state.doneByProject,
            data: formattedData,
            error: null,
            loading: false,
            initialLoad: true,
          },
        };
      }
      return {
        ...state,
        doneByClient: {
          ...state.doneByClient,
          data: formattedData,
          error: null,
          loading: false,
          initialLoad: true,
        },
      };
    }
    const key = `doneBy${payload.data.groupBy.charAt(0).toUpperCase()}${payload.data.groupBy.slice(1)}`;
    return {
      ...state,
      [key]: {
        ...state[key],
        data: payload.data.res,
        error: null,
        loading: false,
        initialLoad: true,
      },
    };
  }
  return {
    ...state,
    done: {
      ...state.done,
      data: payload.data.res,
      error: null,
      loading: false,
      initialLoad: true,
    },
  };
};

const getTodoApprovalsRequest = (state, payload) => {
  if (payload.data?.groupBy) {
    const key = `todoBy${payload.data.groupBy.charAt(0).toUpperCase()}${payload.data.groupBy.slice(1)}`;
    return {
      ...state,
      [key]: {
        ...state[key],
        error: null,
        loading: true,
      },
    };
  }
  return {
    ...state,
    todo: {
      ...state.todo,
      error: null,
      loading: true,
    },
  };
};
const getTodoApprovalsRequestFailure = (state, action) => {
  if (action.data?.groupBy) {
    const key = `todoBy${action.data.groupBy.charAt(0).toUpperCase()}${action.data.groupBy.slice(1)}`;
    return {
      ...state,
      [key]: {
        ...state[key],
        error: action.error,
        loading: false,
      },
    };
  }
  return {
    ...state,
    todo: {
      ...state.todo,
      error: action.error,
      loading: false,
    },
  };
};
const getTodoApprovalsRequestSuccess = (state, payload) => {
  if (payload.data?.groupBy) {
    const key = `todoBy${payload.data.groupBy.charAt(0).toUpperCase()}${payload.data.groupBy.slice(1)}`;
    return {
      ...state,
      [key]: {
        ...state[key],
        data: payload.data.res,
        error: null,
        loading: false,
        initialLoad: true,
      },
    };
  }
  return {
    ...state,
    todo: {
      ...state.todo,
      data: payload.data.res,
      error: null,
      loading: false,
      initialLoad: true,
    },
  };
};

export default handleActions(
  {
    [types.APPROVE_REQUEST]: approveRequest,
    [types.APPROVE_REQUEST_FAILURE]: approveRequestFailure,
    [types.APPROVE_REQUEST_SUCCESS]: approveRequestSuccess,
    [types.DECLINE_REQUEST]: declineRequest,
    [types.DECLINE_REQUEST_FAILURE]: declineRequestFailure,
    [types.DECLINE_REQUEST_SUCCESS]: declineRequestSuccess,
    [types.GET_DONE_APPROVALS_REQUEST]: getDoneApprovalsRequest,
    [types.GET_DONE_APPROVALS_REQUEST_FAILURE]: getDoneApprovalsRequestFailure,
    [types.GET_DONE_APPROVALS_REQUEST_SUCCESS]: getDoneApprovalsRequestSuccess,
    [types.GET_TODO_APPROVALS_REQUEST]: getTodoApprovalsRequest,
    [types.GET_TODO_APPROVALS_REQUEST_FAILURE]: getTodoApprovalsRequestFailure,
    [types.GET_TODO_APPROVALS_REQUEST_SUCCESS]: getTodoApprovalsRequestSuccess,
  },
  initialState
);
